import React from 'react';
import './Footer.css';
const Footer = () => {
    return <div className='footer'>AtEventz</div>;
};

export default Footer;
